export * as guests from '@wix/auto_sdk_events_guests/meta';
export * as notifications from '@wix/auto_sdk_events_notifications/meta';
export * as scheduleBookmarks from '@wix/auto_sdk_events_schedule-bookmarks/meta';
export * as schedule from '@wix/auto_sdk_events_schedule/meta';
export * as staffMembers from '@wix/auto_sdk_events_staff-members/meta';
export * as categories from '@wix/auto_sdk_events_categories/meta';
export * as eventsSettings from '@wix/auto_sdk_events_events-settings/meta';
export * as forms from '@wix/auto_sdk_events_forms/meta';
export * as orders from '@wix/auto_sdk_events_orders/meta';
export * as rsvp from '@wix/auto_sdk_events_rsvp/meta';
export * as tickets from '@wix/auto_sdk_events_tickets/meta';
export * as ticketDefinitions from '@wix/auto_sdk_events_ticket-definitions/meta';
export * as ticketReservations from '@wix/auto_sdk_events_ticket-reservations/meta';
export * as policies from '@wix/auto_sdk_events_policies/meta';
export * as rsvpV2 from '@wix/auto_sdk_events_rsvp-v-2/meta';
export * as wixEventsV2 from '@wix/auto_sdk_events_wix-events-v-2/meta';
export * as ticketDefinitionsV2 from '@wix/auto_sdk_events_ticket-definitions-v-2/meta';
